import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const updateTraceStepContext = React.createContext({});
export let updateTraceStepMachine: any;

const MODULE_NAME = 'machines.updateTraceStep';

export const useSMUpdateTraceStep = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updateTraceStepMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updateTraceStepMachine);

  return {
    updateTraceStepMachine,
    updateTraceStepState: state,
    updateTraceStepSend: send,
  };
};
